// extracted by mini-css-extract-plugin
module.exports = {"root":"_3d5UcX3IiC0XtrfRxAjBkX","tv":"b3SP2P7OzGaEGDGbtpW3F"};